<section
    class="relative flex w-488 flex-col rounded-t-xl border border-border-300 bg-surface-A transition-all"
    interactaResize
    [attr.aria-hidden]="!isBannerVisible()"
    [attr.inert]="!isBannerVisible() ? '' : null"
    [attr.role]="currOpStateInProgress() ? 'status' : 'alert'"
    [ngClass]="{ 'shadow-upload': isBannerVisible() }"
    [resizeAxis]="'height'"
    [style.bottom.px]="sectionHeight()"
    [style.transform]="
        'translateY(' +
        (!isBannerVisible()
            ? '100%'
            : isBannerCollapsed()
              ? 'calc(100% - 56px)'
              : '0') +
        ')'
    "
    [style.transition-duration.ms]="ANIMATIONS_DURATION"
    (changeSize)="sectionHeight.set($event.height)"
>
    <!-- HEADER -->
    <div class="flex h-56 items-center gap-x-16 p-16">
        <p
            class="interacta-banner-title typo-sm-bold"
            [innerHtml]="titleLabel()"
        ></p>

        <button
            class="ml-auto"
            interacta-icon-button
            type="button"
            [icon]="isBannerCollapsed() ? 'chevron-big-up' : 'minus'"
            [label]="
                (isBannerCollapsed()
                    ? 'UI.BUTTON.MAXIMIZE'
                    : 'UI.BUTTON.MINIMIZE'
                ) | translate
            "
            [size]="'small'"
            [style]="'text'"
            (click)="onCollapseClick()"
        ></button>

        <button
            interacta-icon-button
            type="button"
            [disabled]="disableCloseButton()"
            [icon]="'close'"
            [label]="'UI.BUTTON.CLOSE' | translate"
            [size]="'small'"
            [style]="'text'"
            (click)="onCloseClick()"
        ></button>
    </div>
    <!-- CONTENT -->
    <div class="flex grow flex-col gap-8 px-16 pb-16">
        @if (currOpStateInProgress()) {
            <div class="mb-16 flex w-full justify-end rounded bg-surface-100">
                <button
                    interacta-button
                    type="button"
                    [disabled]="isBannerBusy()"
                    [label]="
                        'BULK_WORKFLOW_TRANSITION.BANNER.CANCEL_OPERATIONS_BUTTON'
                            | translate
                    "
                    (click)="abortCurrentOperation()"
                ></button>
            </div>
        }
        <div class="flex grow items-start gap-x-8">
            <div class="mb-16 grow">
                <p class="grow typo-sm">
                    {{
                        (currOpStateInProgress()
                            ? 'BULK_WORKFLOW_TRANSITION.BANNER.OPERATIONS_IN_PROGRESS_DESCRIPTION'
                            : 'BULK_WORKFLOW_TRANSITION.BANNER.OPERATIONS_DONE_DESCRIPTION'
                        ) | translate
                    }}
                </p>
                @if (currOpSuccessPostsCount() > 0) {
                    <ng-container
                        *ngTemplateOutlet="
                            detailRow;
                            context: {
                                icon: 'check',
                                isError: false,
                                label: okLabel(),
                            }
                        "
                    />
                }

                @if (currOpFailedPostsCount() > 0) {
                    <ng-container
                        *ngTemplateOutlet="
                            detailRow;
                            context: {
                                icon: 'warning',
                                isError: true,
                                label: errorLabel(),
                            }
                        "
                    />
                }

                @let cancelled =
                    currOpTotalPosts() -
                    currOpSuccessPostsCount() -
                    currOpFailedPostsCount();
                @if (cancelled > 0 && !currOpStateInProgress()) {
                    <ng-container
                        *ngTemplateOutlet="
                            detailRow;
                            context: {
                                icon: 'check-circle-indeterminate',
                                isError: false,
                                label: abortedLabel(),
                            }
                        "
                    />
                }
            </div>

            @if (currOpStateInProgress()) {
                <interacta-loader class="shrink-0" [size]="'large'" />
            }
        </div>
        @if (!currOpStateInProgress()) {
            <button
                interacta-button
                type="button"
                [label]="
                    'BULK_WORKFLOW_TRANSITION.BANNER.GO_TO_REPORT_BUTTON'
                        | translate
                "
                [style]="'outlined'"
                (click)="onOpenReportClick()"
            ></button>
        }
    </div>
</section>

<ng-template #detailRow let-icon="icon" let-isError="isError" let-label="label">
    <div
        class="mt-8 flex items-center gap-x-12 pl-8"
        [ngClass]="{
            'text-text-error': isError,
        }"
    >
        <interacta-icon class="block size-24" [icon]="icon" />
        <p class="typo-sm" [innerHTML]="label"></p>
    </div>
</ng-template>
